import {
  CurrentUser,
  LanguageResponse,
  Password,
  User,
  UserSettings,
  UserTwoFactorStatus,
} from '../types/User.types';
import API from './ApiBase';

export const getAllUsers = async () => {
  const response = await API.get<User[]>('/users');
  return response;
};

export const getCurrentUser = async () => {
  const reponse = await API.get<CurrentUser>('/users/me');
  return reponse;
};

export const updateCurrentUser = async (requestBody: CurrentUser) => {
  const response = await API.patch<CurrentUser>('/users/me', requestBody);
  return response;
};

export const deleteCurrentUser = async (confirmation: 'delete my account') => {
  const response = await API.delete<{ message: string }>('/users/me', {
    data: { confirmation },
    // ModalDeleteAccount renders the refusal inside the dialog so the typed
    // confirmation is not thrown away. Without this the interceptor also toasts
    // it and the user reads the same sentence twice.
    skipErrorToast: true,
  });
  return response;
};

export const changePassword = async (password: Password) => {
  const response = await API.patch<{ message: string }>(
    '/users/change-password',
    password
  );
  return response;
};

export const getAvailableLanguages = async () => {
  const response = await API.get<LanguageResponse[]>('/users/settings/languages');
  return response.data.map((lang) => ({
    value: lang.code,
    label: lang.name,
  }));
};

export const getAvailableTimezones = async () => {
  const response = await API.get<string[]>('/users/settings/timezones');
  return response.data.map((tz) => ({
    value: tz,
    label: tz,
  }));
};

export const getUserSettings = async () => {
  const response = await API.get<UserSettings>('/users/settings');
  return response.data;
};

export const updateUserSettings = async (settings: UserSettings) => {
  const response = await API.put<UserSettings>('/users/settings', settings);
  return response.data;
};

export const getMySecuritySettings = async () => {
  const response = await API.get<UserTwoFactorStatus>('/users/me/security');
  return response.data;
};

export const disableMyTwoFactor = async () => {
  const response = await API.delete<UserTwoFactorStatus>('/users/me/security/2fa');
  return response.data;
};
